module.exports = __webpack_public_path__ + "img/rules_icon_gif.c4ceea69.gif";